import { useHistory } from 'react-router-dom';
import { authenticate, continueAsGuest, goToLogin } from 'src/model/services/profile.service';
import { ProfileState } from 'src/model/state/partials/profile.model';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { stateConnect } from 'src/hooks/state/use-app-state';
import { useShowError } from 'src/utils/providers/ShowErrorsProvider';
import { useNavigationHistory } from 'src/utils/providers/NavigationHistoryProvider';
import useMyFavoriteAddMutation from 'src/hooks/React_Query/Customer/Buyer/MyFavorites/useMyFavoriteAddMutation';


const AuthenticationManager = (props: ProfileState & { children: React.ReactNode }) => {
    const showError = useShowError();
    const { t } = useTranslation();
    const history = useHistory();
    const { previousPage } = useNavigationHistory();
    const useAddFavorite = useMyFavoriteAddMutation();

    useEffect(() => {
        if (!props?.loaded && !props?.error && !props?.loading) {
            authenticate();
        }
        const timer = setInterval(authenticate, 600000); // check periodically
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        if (props?.loaded && props?.user && !props?.error && !props?.loading) {
            let pendingAction = sessionStorage.getItem('pendingFavoriteAction');
            let shouldCleanupSession = false;
            let shouldCleanupUrl = false;
            
            if (!pendingAction) {
                const searchParams = new URLSearchParams(window.location.search);
                const action = searchParams.get('pendingFavoriteAction');
                const productId = searchParams.get('productId');
                
                if (action && productId) {
                    pendingAction = JSON.stringify({ action, productId });
                    shouldCleanupUrl = true;
                }
            } else {
                shouldCleanupSession = true;
            }
            
            if (pendingAction) {
                try {
                    const { productId, action } = JSON.parse(pendingAction);
                    if (action === 'add') {
                        useAddFavorite.mutate({ productIds: [parseInt(productId)] });
                    }
                    
                    if (shouldCleanupSession) {
                        sessionStorage.removeItem('pendingFavoriteAction');
                    }
                    
                    if (shouldCleanupUrl) {
                        const newUrl = new URL(window.location.href);
                        newUrl.searchParams.delete('pendingFavoriteAction');
                        newUrl.searchParams.delete('productId');
                        window.history.replaceState({}, document.title, newUrl.toString());
                    }
                } catch (error) {
                    console.error('Error processing pending favorite action:', error);
                    sessionStorage.removeItem('pendingFavoriteAction');
                }
            }
        }
    }, [props?.user, props?.loaded, useAddFavorite]);

    if (props?.needsToLogin) {
        goToLogin(window?.location?.href, previousPage);
    } else if (props?.sessionExpired) {
        showError({
            error: {
                messageKey: 'SESSION_EXPIRED'
            },
            acceptButtonText: t('session_expired_button'),
            showCancel: true,
            onAcceptClick: () => goToLogin(window?.location?.href, previousPage),
            onCancelClick: () => {
                continueAsGuest();
                history.push('/products');
            }
        });
    } else if (props.error) {
        showError({
            error: props?.error,
            acceptButtonText: t('common_dialog_retry'),
            onAcceptClick: authenticate,
        });
    }

    return (
        <>
            {props?.loaded && !props?.error && props?.children }
        </>
    )
}

export default stateConnect(AuthenticationManager, state => state?.profile);